export default function (id) {
  let window = id ? `cliente.${id}` : 'cliente.new'
  !this.$uloc.window.get(window) && this.$uloc.window.new({
    wid: window,
    title: 'Cliente' + (id ? ` #${id}` : ''),
    width: '1000',
    height: '800',
    minHeight: '500px',
    backdrop: false,
    clickOutside: false,
    maximize: true,
    windowClass: 'erp-window erp-window-macos-code',
    contentClass: 'overflow-hidden',
    props: {
      id: id,
      listClassificacao: this.listClassificacao,
      listLeiloeiros: this.listLeiloeiros,
      router: this.$router
    }
  }, () => import('../components/window/Cliente.vue'))
    .then((wid) => {
      this.$uloc.window.listen(wid, {
        update: (wid, val) => {
          this.$emit('update')
          this.load && this.load()
        }
      })
    }) // return wid
}
